(function () {
  angular
    .module('kareo.ui.shared.directives.user.k-user-type-view', [
      'kareo.ui.shared.directives.templates'
    ])
    .component('kUserTypeView', {
      bindings: {
        onChange: '&',
        isProvider: '<?',
        hideProviderOption: '<?'
      },
      controller: _controller(),
      controllerAs: 'vm',
      template: require('./k-user-type-view.pug')()
    });

  function _controller() {
    var instanceCount = 0;
    return function controller() {
      const vm = this;

      vm.instanceNum = ++instanceCount;
    };
  }
})();
